/* eslint-disable import/prefer-default-export */
export { default as PathLocationSection } from './pathLocationSection';
